export default "__VITE_ASSET__b044184b__"